// extracted by mini-css-extract-plugin
export var breadcrumb = "_1-2";
export var breadcrumbArrow = "_1-3";
export var breadcrumbs = "_1-0";
export var link = "_1-4";
export var small = "_1-1";